export const selectNfeError = state => state.nfe.error
export const selectNfeTablesData = state => state.nfe.nfeTablesData
export const selectProducer = state => state.nfe.producer
export const selectCFOP = state => state.nfe.CFOP

